import { Badge } from '../../../../components/atoms/badge/badge';

interface Props {
  active: boolean;
}

export const UserStatusBadge = ({ active }: Props) =>
  active ? (
    <Badge variant="success">Ativo</Badge>
  ) : (
    <Badge variant="neutral">Inativo</Badge>
  );
